<template>
  <v-container style="max-width: 1800px">
    <v-card class="ma-4">
      <v-toolbar color="primary" dark>
        Cliente
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text v-if="contact">
        <v-container class="ma-4">
          <v-row>
            <v-col cols="12" md="">
              <v-text-field
                label="Nome"
                v-model="contact.name"
                hide-details="auto"
                :disabled="disabled"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Email"
                v-model="contact.email"
                hide-details="auto"
                :disabled="disabled"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Fone"
                v-model="contact.phone"
                hide-details="auto"
                v-mask= "(contact.phone.length<=13)?'(##)####-####':'(##)#####-####'"
              :disabled="disabled"
              >
              </v-text-field>
              <!-- <v-btn @click="teste">Teste</v-btn> -->
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "contact-card",
  props: ["contact","disabled"],
  methods: {
    // teste(){
    //   alert(this.contact.phone.length)
    // }

  },
  mounted(){
  // alert(JSON.stringify(this.contact))
  }

};

</script>

<style scoped>
</style>